module.exports = __webpack_public_path__ + "assets/download-document.1062a0a1.svg";